import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import Reveal from 'reveal.js';
import 'reveal.js/dist/reveal.css';
import 'reveal.js/dist/theme/white.css';
import 'reveal.js/dist/reset.css';
import html2canvas from 'html2canvas';
import './Overwrite.css';
import PptxGenJS from 'pptxgenjs';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { jsPDF } from 'jspdf';
import ReportsTemplate from '../../_components/templates/ReportTemplate';
import EnrollmentTopCards from '../../Visuals/EnrollmentTopCards';
import EnrollmentTypeChart from '../../Visuals/EnrollmentType';
import MedicalVsRxPlanPaid from '../../Visuals/MedicalVsRxPlanPaid';
import {
  Button,
  CardComponent,
  Switch,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import NetworkLeakageImpact from '../../Visuals/NetworkLeakage';
import { useStores } from '../../stores';
import HighCostClaimantChart from '../../Visuals/HighCostClaimantsChart';
import ClaimantsDistribution from '../../Visuals/ClaimantsDistribution';
import RiskStratification from '../../Visuals/RiskStratification';
import TopChronicDiseases from '../../Visuals/TopChronicDiseases';
import TopServicesMedicalSpend from '../../Visuals/TopServicesMedicalSpend';
import TopDrugsTable from '../../Visuals/TopDrugsTable';
import StopLossAggregateTable from '../../Visuals/StopLossAggregateTable';
import PaidClaimsTrend from '../../Visuals/PaidClaimsTrend';
import TopPlanPaidTable from '../../Visuals/TopPlanPaidTable';
import CareQualityMeasuresTable from '../../Visuals/CareQualityMeasuresTable';
// import SavingsUtilizationTopCards from '../../Visuals/SavingsUtilizationTopCards';
import SavingsUtilizationTopCards from '../../Visuals/SavingsUtilizationTopCards';
import SavingsUtilizationTables from '../../Visuals/SavingsUtilizationTables';
import { formatDate } from '../../core-utils/helper-utils/helper';
import QuaterlyReportModal from '../../_components/molecules/QuaterlyReportModal';
import CareNavigationOverview from '../../Visuals/CareNavigationOverview';
import CareNavigationMembers from '../../Visuals/CareNavigationMembers';
import CareNavigationFeedback from '../../Visuals/CareNavigationFeedback';
import Loader from '../../_components/molecules/Loader';
import {
  getAggregateReport,
  getCareNavigationData,
  getCareNavigationMoi,
  getCareQualityMeasures,
  getCaseSurveys,
  getClaimantsDistribution,
  getCohortInsights,
  getEmployeeDependentPlanPaid,
  getEmployeeDependentSpend,
  getEnrollmentsHealthCare,
  getFillsAndBreakdownCostTrend,
  getHighCostClaimants,
  getNetworkSummary,
  getPaidClaimsTrend,
  getRiskStratification,
  getSavingsProgramDetails,
  getSavingsUtilizatonSummary,
  getStoplossSummary,
  getTopChronicDiseases,
  getTopDrugsTableData,
  getTopMedpharmaDrugs,
  getTopPlanPaid,
  getTotalEligible,
} from '../../core-utils/helper-utils/quaterlyReportHelper';
import { EnrollmentMetricsAPIResponse } from '../../core-utils/helper-utils/enrollmentMetricsHelpers';
import CohortInsightTable from '../../Visuals/CohortInsightTable';

export interface ReportsPptProps {}

const ReportsPpt: React.FC<ReportsPptProps> = observer(({}) => {
  const employerGroupStore = useStores().employerGroupStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const careNavigatorStore = useStores().careNavigatorStore;

  const maxClaimDate =
    employerGroupStore?.employerGroupResponseData?.max_claim_date;

  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    aggregationParameter,
  } = quaterlyReportStore;

  const deckDivRef = useRef<HTMLDivElement>(null);
  const deckRef = useRef<Reveal.Api | null>(null);
  const exportInProgressRef = useRef(false);

  const useStyles = makeStyles()({
    reveal: {
      border: `10px solid ${patientAccessTheme.palette.grey[300]}`,
      height: '750px',
    },
    exportGrid: {
      margin: '20px',
      display: 'flex',
      gap: '15px',
      flexDirection: 'column',
    },
    datesContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.1rem',
    },

    switch: {
      display: 'flex',
      gap: '20px',
      alignItems: 'center',
    },
    riskStratificationRoot: {
      width: '100%',
      display: 'flex',
      gap: '16px',
    },
    topChronicDiseasesCards: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    medicalSpendTables: {
      display: 'flex',
      gap: '24px',
    },
    exportNote: {
      position: 'absolute',
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      width: '70%',
      height: '70%',
      zIndex: 1,
      top: '20%',
      left: '10%',
      backdropFilter: 'blur(10px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    exportText: {
      padding: '20px',
      fontSize: '16px',
      fontFamily: 'Inter',
      fontWeight: 500,
      lineHeight: '16px',
      color: patientAccessTheme.palette.status.white,
      backgroundColor: patientAccessTheme.palette.grey[900],
      height: 'fit-content',
      width: 'fit-content',
    },
  });

  const { classes } = useStyles();

  const [openQuaterlyReport, setOpenQuaterlyReport] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  //Api Call States
  const [stopLossSummary, setStopLossSummary] = useState<any>('');
  const [aggregateReport, setAggregateReport] = useState<any[]>([]);
  const [eligibleData, setEligibleData] = useState<any>('');
  const [employeeDependentSpend, setEmployeeDependentSpend] = useState<any>('');
  const [healthcareData, setHealthcareData] = useState<
    EnrollmentMetricsAPIResponse[]
  >();
  const [
    employeeDependentPlanPaid,
    setEmployeeDependentPlanPaid,
  ] = useState<any>('');
  const [riskStratification, setRiskStratification] = useState<any>('');
  const [topDiagnosisByCost, setTopDiagnosisByCost] = useState<any>([]);
  const [topDiagnosisByMember, setTopDiagnosisByMember] = useState<any>([]);
  const [highCostClaimants, setHighCostClaimants] = useState<any>([]);
  const [claimantsDistribution, setClaimantsDistribution] = useState<any>([]);
  const [paidClaimsTrend, setPaidClaimsTrend] = useState<any>([]);
  const [topPlanPaid, setTopPlanPaid] = useState<any>('');
  const [serviceTopDrugs, setServiceTopDrugs] = useState<any>([]);
  const [medPharmaTopDrugs, setMedPharmaTopDrugs] = useState<any>([]);
  const [topPharmacyPlanPaid, setTopPharmacyPlanPaid] = useState<any>('');
  const [topDrugs, setTopDrugs] = useState<any>([]);
  const [careQualityDistribution, setCareQualityDistribution] = useState<any>(
    [],
  );
  const [savingsSummary, setSavingsSummary] = useState<any>([]);
  const [fillsBreakdown, setFillsBreakdown] = useState<any>([]);
  const [savingsProgram, setSavingsProgram] = useState<any>([]);
  const [inNetworkSummary, setInNetworkSummary] = useState<any>([]);
  const [outNetworkSummary, setOutNetworkSummary] = useState<any>([]);
  const [
    currentMonthCareNavigation,
    setCurrentMonthCareNavigation,
  ] = useState<any>([]);
  const [planYearCareNavigation, setPlanYearCareNavigation] = useState<any>([]);
  const [careNavigationMoi, setCareNavigationMoi] = useState<any>([]);
  const [careNavigationFeedback, setCareNavigationFeedback] = useState<any>([]);
  const [topSpendingInsights, setTopSpendingInsights] = useState<any>({});
  const [surgeInSpendingInsights, setSurgeInSpendingInsights] = useState<any>(
    {},
  );
  const [emergingSpendingInsights, setEmergingSpendingInsights] = useState<any>(
    {},
  );

  const shouldCareNavigationSlideRender = (data: any) => {
    return (
      data?.openCases?.some((item: any) => item.count > 0) ||
      data?.engagements?.total > 0 ||
      data?.careNavigators?.some((item: any) => item.count > 0) ||
      data?.caseSurveys?.totalClosedCases > 0 ||
      data?.caseSurveys?.savingsTotal > 0 ||
      data?.caseSurveys?.caseTypes?.some((item: any) => item.count > 0) ||
      data?.engagements?.data?.some((item: any) => item.count > 0)
    );
  };

  const apiCalls = () => {
    const params: [any, any, any, any, any, any, any] = [
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      employerGroupStore,
      quaterlyReportStore,
    ];
    const params1: [any, any] = [paidStartDate, paidEndDate];

    const apis = [
      getStoplossSummary(...params),
      getAggregateReport(...params),
      getTotalEligible(...params, cohortDetailsStore),
      getEmployeeDependentSpend(...params, cohortDetailsStore),
      getEnrollmentsHealthCare(...params, maxClaimDate),
      getEmployeeDependentPlanPaid(...params, cohortDetailsStore),
      getRiskStratification(...params, cohortDetailsStore),
      getTopChronicDiseases(...params, maxClaimDate, 'cost'),
      getTopChronicDiseases(...params, maxClaimDate, 'member'),
      getHighCostClaimants(...params, cohortDetailsStore),
      getClaimantsDistribution(...params, cohortDetailsStore),
      getPaidClaimsTrend(...params, cohortDetailsStore),
      getTopPlanPaid(...params, true),
      getTopMedpharmaDrugs(...params, 'service'),
      getTopMedpharmaDrugs(...params, 'medpharma'),
      getTopPlanPaid(...params, false),
      getTopDrugsTableData(...params),
      getCareQualityMeasures(...params1, employerGroupStore),
      getSavingsUtilizatonSummary(...params),
      getFillsAndBreakdownCostTrend(...params),
      getSavingsProgramDetails(...params, '', 0),
      getNetworkSummary(...params, cohortDetailsStore, 'IN'),
      getNetworkSummary(...params, cohortDetailsStore, 'OUT'),
      getCareNavigationData(...params1, careNavigatorStore, true),
      getCareNavigationData(...params1, careNavigatorStore, false),
      getCareNavigationMoi(...params1, employerGroupStore, careNavigatorStore),
      getCaseSurveys(careNavigatorStore),
      getCohortInsights(...params),
    ];
    setLoading(true);
    Promise.allSettled(apis)
      .then((result: any) => {
        setStopLossSummary(result[0].value);
        setAggregateReport(result[1].value);
        setEligibleData(result[2].value);
        setEmployeeDependentSpend(result[3].value);
        setHealthcareData(result[4].value);
        setEmployeeDependentPlanPaid(result[5].value);
        setRiskStratification(result[6].value);
        setTopDiagnosisByCost(result[7].value);
        setTopDiagnosisByMember(result[8].value);
        setHighCostClaimants(result[9].value);
        setClaimantsDistribution(result[10].value);
        setPaidClaimsTrend(result[11].value);
        setTopPlanPaid(result[12].value);
        setServiceTopDrugs(result[13].value);
        setMedPharmaTopDrugs(result[14].value);
        setTopPharmacyPlanPaid(result[15].value);
        setTopDrugs(result[16].value);
        setCareQualityDistribution(result[17].value);
        setSavingsSummary(result[18].value);
        setFillsBreakdown(result[19].value);
        setSavingsProgram(result[20].value);
        setInNetworkSummary(result[21].value);
        setOutNetworkSummary(result[22].value);
        setCurrentMonthCareNavigation(result[23].value);
        setPlanYearCareNavigation(result[24].value);
        setCareNavigationMoi(result[25].value);
        setCareNavigationFeedback(result[26].value);
        result[27]?.value?.forEach((temp: any) => {
          switch (temp.analysis_type) {
            case 'top spending':
              setTopSpendingInsights(temp);
              break;
            case 'emerging spending':
              setEmergingSpendingInsights(temp);
              break;
            case 'surge in spending':
              setSurgeInSpendingInsights(temp);
              break;
            default:
              break;
          }
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const exportSlides = async (format: string) => {
    if (!deckDivRef.current || exportInProgressRef.current) {
       
      console.error(
        'deckDivRef reference is null or export already in progress',
      );
      return;
    }

    exportInProgressRef.current = true;

    // Disable Reveal.js controls
    if (deckRef.current) {
      deckRef.current.configure({ controls: false, keyboard: false });
    }

    const slides = Array.from(
      deckDivRef.current.querySelectorAll('.slides section'),
    );
    const slideNumber: any = deckRef.current?.getIndices();
    const currentSlide: any = slides[slideNumber.h];
    currentSlide.style.opacity = '0';

    const exportCanvas = async (slide: any) => {
      const originalOpacity = slide.style.opacity;
      const originalDisplay = slide.style.display;
      if (window.innerWidth < 1600) {
        slide.style.transform = 'scale(0.75)';
        slide.style.transformOrigin = 'top left';
        slide.style.width = '115%';
        slide.style.height = '110%';
      }
      slide.style.opacity = '1';
      slide.style.display = 'block';
      const canvas = await html2canvas(slide, { scale: 2 });

      slide.style.opacity = originalOpacity;
      slide.style.display = originalDisplay;
      if (window.innerWidth < 1600) {
        slide.style.transform = '';
        slide.style.transformOrigin = '';
        slide.style.width = '';
        slide.style.height = '';
      }
      return canvas;
    };

    try {
      if (format === 'pptx') {
        const pptx = new PptxGenJS();
        for (const slide of slides) {
          if (!exportInProgressRef.current) {
            return;
          }
          const canvas = await exportCanvas(slide);
          const imgData = canvas.toDataURL('image/png');

          const slidePPT = pptx.addSlide();
          slidePPT.addImage({
            data: imgData,
            x: 0,
            y: 0,
            w: '100%',
            h: '100%',
          });
        }
        await pptx.writeFile({ fileName: 'presentation.pptx' });
      } else if (format === 'pdf') {
        const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: [1310, 740],
        });
        for (let i = 0; i < slides.length; i++) {
          if (!exportInProgressRef.current) {
            return;
          }
          const canvas = await exportCanvas(slides[i]);
          const imgData = canvas.toDataURL('image/png');
          if (i !== 0) {
            pdf.addPage();
          }
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        }
        pdf.save('presentation.pdf');
      }
    } finally {
      exportInProgressRef.current = false;
      currentSlide.style.opacity = '1';
      // Re-enable Reveal.js controls
      if (deckRef.current) {
        deckRef.current.configure({ controls: true, keyboard: true });
      }
    }
  };

  useEffect(() => {
    if (loading) {
      apiCalls();
      return;
    }

    if (deckRef.current) {
      deckRef.current.destroy();
      deckRef.current = null;
    }

    // Wait for React to render DOM updates after loading = false
    const timeout = setTimeout(() => {
      if (deckDivRef.current) {
        deckRef.current = new Reveal(deckDivRef.current, {
          controls: true,
          progress: true,
          slideNumber: true,
          history: false,
          center: false,
          transition: 'none',
          width: 1320,
          height: 740,
          embedded: true,
          viewDistance: 30,
          disableLayout: true,
        });

        deckRef.current.initialize();
      }
    }, 100); // small delay to let DOM update

    return () => {
      clearTimeout(timeout);
      try {
        if (deckRef.current) {
          deckRef.current.destroy();
          deckRef.current = null;
        }
      } catch (e) {
         
        console.error('Reveal.js destroy call failed.');
      }
    };
  }, [loading]);

  useEffect(() => {
    setLoading(true);
  }, [
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    paidStartDate,
    aggregationParameter,
  ]);

  const PptSlides = () => {
    return (
      <Grid style={{ width: '1345px' }}>
        <div className={`reveal ${classes.reveal}`} ref={deckDivRef}>
          <div className="slides">
            {loading ? (
              <Loader />
            ) : (
              <>
                {/* Financial Performance YTD */}
                {aggregateReport?.length > 0 && (
                  <ReportsTemplate
                    pageTitle="Financial Performance YTD"
                    body={
                      <>
                        <StopLossAggregateTable
                          incurredStartDate={incurredStartDate}
                          incurredEndDate={incurredEndDate}
                          data={{
                            stopLossSummary,
                            isAggregateDataPresent:
                              stopLossSummary?.aggregate_coverage ?? false,
                            aggregateReport,
                          }}
                        />
                      </>
                    }
                  />
                )}

                {/* Enrollment Slide */}
                {eligibleData?.totalEligibleCount > 0 && (
                  <ReportsTemplate
                    pageTitle="Enrollment"
                    body={
                      <Grid
                        style={{ width: '100%' }}
                        sx={{
                          flexDirection: 'column',
                        }}
                      >
                        <EnrollmentTopCards
                          data={{ eligibleData, employeeDependentSpend }}
                        />
                        <Grid style={{ display: 'flex' }}>
                          <EnrollmentTypeChart data={{ healthcareData }} />
                          <MedicalVsRxPlanPaid
                            data={{ employeeDependentPlanPaid }}
                          />
                        </Grid>
                      </Grid>
                    }
                  />
                )}

                {/* Risk Stratification */}
                {(topDiagnosisByCost?.length > 0 ||
                  topDiagnosisByMember?.length > 0) && (
                  <ReportsTemplate
                    pageTitle={'Risk Stratification by Chronic Conditions'}
                    body={
                      <Grid className={classes.riskStratificationRoot}>
                        <CardComponent
                          title={
                            'Stratification of Members by Comorbidity of Chronic Conditions'
                          }
                          body={
                            <Grid
                              style={{
                                paddingTop: '90px',
                              }}
                            >
                              <RiskStratification
                                data={{ riskStratification }}
                              />
                            </Grid>
                          }
                          width="780px"
                        />
                        <Grid className={classes.topChronicDiseasesCards}>
                          <TopChronicDiseases
                            type={'cost'}
                            data={{ topDiagnosis: topDiagnosisByCost }}
                          />
                          <TopChronicDiseases
                            data={{ topDiagnosis: topDiagnosisByMember }}
                            type={'member'}
                          />
                        </Grid>
                      </Grid>
                    }
                  />
                )}

                {/* Top Spending Categories */}
                {topSpendingInsights?.result?.length > 0 && (
                  <ReportsTemplate
                    pageTitle={'Top Spending Categories'}
                    body={<CohortInsightTable data={topSpendingInsights} />}
                  />
                )}

                {/* Surge In Spending Categories */}
                {surgeInSpendingInsights?.result?.length > 0 && (
                  <ReportsTemplate
                    pageTitle={'Surge In Spending Categories'}
                    body={<CohortInsightTable data={surgeInSpendingInsights} />}
                  />
                )}

                {/* Emerging Spending Categories */}
                {emergingSpendingInsights?.result?.length > 0 && (
                  <ReportsTemplate
                    pageTitle={'Emerging Spending Categories'}
                    body={
                      <CohortInsightTable data={emergingSpendingInsights} />
                    }
                  />
                )}

                {/* High Cost Claimants */}
                {!Object.values(highCostClaimants).every(
                  (val) => val === 0,
                ) && (
                  <ReportsTemplate
                    pageTitle="High Cost Claimants"
                    body={
                      <Grid
                        style={{
                          width: '100%',
                          display: 'flex',
                          gap: '20px',
                          alignItems: 'center',
                        }}
                      >
                        <HighCostClaimantChart data={{ highCostClaimants }} />
                        <ClaimantsDistribution
                          data={{ claimantsDistribution }}
                        />
                      </Grid>
                    }
                  />
                )}

                {/* Medical Trend & Impact */}
                {paidClaimsTrend?.costTrend
                  ?.filter((temp: any) => temp.claim_type === 'medical')
                  ?.some((entry: any) => Number(entry.total_cost) > 0) && (
                  <ReportsTemplate
                    pageTitle="Medical Trend & Impact"
                    body={
                      <Grid
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                          marginTop: '1rem',
                        }}
                      >
                        <PaidClaimsTrend
                          data={{ paidClaimsTrend }}
                          isMedical={true}
                        />
                        <TopPlanPaidTable data={{ topPlanPaid }} />
                      </Grid>
                    }
                  />
                )}

                {/* Medical Spend - Top Contributors */}
                {(serviceTopDrugs?.totalCount?.[0]?.totalCount > 0 ||
                  medPharmaTopDrugs?.totalCount?.[0]?.totalCount > 0) && (
                  <ReportsTemplate
                    pageTitle={'Medical Spend - Top Contributors'}
                    body={
                      <Grid className={classes.medicalSpendTables}>
                        <TopServicesMedicalSpend
                          data={{ topDrugs: serviceTopDrugs?.data }}
                          type="service"
                        />
                        <TopServicesMedicalSpend
                          data={{ topDrugs: medPharmaTopDrugs?.data }}
                          type="medpharma"
                        />
                      </Grid>
                    }
                  />
                )}

                {/* Pharmacy Trend & Impact */}
                {paidClaimsTrend?.costTrend
                  ?.filter((temp: any) => temp.claim_type === 'rx')
                  ?.some((entry: any) => Number(entry.total_cost) > 0) && (
                  <ReportsTemplate
                    pageTitle="Pharmacy Trend & Impact"
                    body={
                      <Grid
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                          marginTop: '1rem',
                        }}
                      >
                        <PaidClaimsTrend
                          data={{ paidClaimsTrend }}
                          isMedical={false}
                        />
                        <TopPlanPaidTable
                          data={{ topPlanPaid: topPharmacyPlanPaid }}
                        />
                      </Grid>
                    }
                  />
                )}

                {/* Pharmacy Claims - Top Contributors */}
                {topDrugs?.length > 0 && (
                  <ReportsTemplate
                    pageTitle="Pharmacy Claims - Top Contributors"
                    body={<TopDrugsTable data={{ topDrugs }} />}
                  />
                )}

                {/* Care Quality Measures */}
                {careQualityDistribution?.length > 0 && (
                  <ReportsTemplate
                    pageTitle="Care Gaps"
                    body={
                      <CareQualityMeasuresTable
                        data={{ careQualityDistribution }}
                      />
                    }
                  />
                )}

                {/* Savings Quarterly Report */}
                {savingsSummary?.length > 0 && (
                  <ReportsTemplate
                    pageTitle="Savings Quarterly Report"
                    body={
                      <SavingsUtilizationTopCards
                        data={{
                          savingsSummary,
                          fillsBreakdown,
                          savingsProgram,
                        }}
                      />
                    }
                  />
                )}

                {/* Savings Quarterly Report Table */}
                {quaterlyReportStore?.tableData?.length > 0 &&
                  quaterlyReportStore.tableData?.map((_, index) => (
                    <ReportsTemplate
                      pageTitle="Savings Quarterly Report"
                      body={<SavingsUtilizationTables index={index} />}
                    />
                  ))}

                {/* Network Utilization */}
                {(inNetworkSummary?.paginatedResults?.length > 0 ||
                  outNetworkSummary?.paginatedResults?.length > 0) && (
                  <ReportsTemplate
                    pageTitle="Network Utilization"
                    body={
                      <NetworkLeakageImpact
                        data={{ inNetworkSummary, outNetworkSummary }}
                      />
                    }
                  />
                )}

                {/* Care Navigation - Current Month */}
                {shouldCareNavigationSlideRender(
                  currentMonthCareNavigation,
                ) && (
                  <ReportsTemplate
                    pageTitle="Care Navigation - Current Month"
                    body={
                      <>
                        <CareNavigationOverview
                          data={{ careNavigation: currentMonthCareNavigation }}
                        />
                      </>
                    }
                  />
                )}

                {/* Care Navigation - Plan Year */}
                {shouldCareNavigationSlideRender(planYearCareNavigation) && (
                  <ReportsTemplate
                    pageTitle="Care Navigation - Plan Year"
                    body={
                      <>
                        <CareNavigationOverview
                          data={{ careNavigation: planYearCareNavigation }}
                        />
                      </>
                    }
                  />
                )}

                {/* Care Navigation - Members Of Interest */}
                {careNavigationMoi?.patientsWithPlanPaid?.length > 0 && (
                  <ReportsTemplate
                    pageTitle="Care Navigation - Members of  Interest"
                    body={
                      <>
                        <CareNavigationMembers data={{ careNavigationMoi }} />
                      </>
                    }
                  />
                )}

                {/* Care Navigation - Feedback */}
                {careNavigationFeedback?.avgRating > 0 && (
                  <ReportsTemplate
                    pageTitle="Care Navigation - Feedback"
                    body={
                      <>
                        <CareNavigationFeedback
                          data={{ careNavigationFeedback }}
                        />
                      </>
                    }
                  />
                )}
              </>
            )}
          </div>
        </div>
      </Grid>
    );
  };

  const Export = () => {
    const [isPdf, setIsPdf] = useState<boolean>(true);
    const [isExport, setIsExport] = useState<boolean>(false);
    return (
      <div className={classes.exportGrid}>
        <div>
          {!isIncurredDate && !isPaidDate ? (
            <Grid className={classes.datesContainer}>
              <Typography
                fontSize="0.9rem"
                fontType="regular"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
              >
                Start Date:
              </Typography>
              <Typography
                fontSize="0.9rem"
                fontType="semiBold"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {formatDate(
                  employerGroupStore.selectedDuration.startDate,
                  'MMM YYYY',
                )}
                {' to '}
                {formatDate(
                  employerGroupStore.selectedDuration.endDate,
                  'MMM YYYY',
                )}
              </Typography>
            </Grid>
          ) : (
            <Grid className={classes.datesContainer}>
              {isIncurredDate && (
                <>
                  <Typography
                    fontSize="0.9rem"
                    fontType="regular"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                  >
                    Incurred Date:
                  </Typography>
                  <Typography
                    fontSize="0.9rem"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {formatDate(incurredStartDate, 'MMM YYYY')}
                    {' to '}
                    {formatDate(incurredEndDate, 'MMM YYYY')}
                  </Typography>
                </>
              )}
              {isPaidDate && (
                <>
                  <Typography
                    fontSize="0.9rem"
                    fontType="regular"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    margin="0.5rem 0 0 0"
                  >
                    Paid Date:
                  </Typography>
                  <Typography
                    fontSize="0.9rem"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {formatDate(paidStartDate, 'MMM YYYY')}
                    {' to '}
                    {formatDate(paidEndDate, 'MMM YYYY')}
                  </Typography>
                </>
              )}
            </Grid>
          )}

          <Button
            onClick={() => {
              setOpenQuaterlyReport(true);
            }}
            height="50px"
            variant="contained"
            label={'Update Duration'}
            width="130px"
            disabled={isExport}
            styleProps={{
              marginTop: '1rem',
            }}
          />
        </div>
        <div className={classes.switch}>
          <Switch
            checked={isPdf}
            handleChange={() => {
              setIsPdf(!isPdf);
            }}
          />
          <Typography>{isPdf ? 'PDF' : 'PPT'}</Typography>
        </div>

        <Button
          onClick={async () => {
            setIsExport(true);
            await exportSlides(isPdf ? 'pdf' : 'pptx');
            setIsExport(false);
          }}
          height="33px"
          variant="contained"
          label={isExport ? 'In Progress' : isPdf ? 'Export PDF' : 'Export PPT'}
          width="130px"
          disabled={isExport}
        />
        {isExport && (
          <div className={classes.exportNote}>
            <div className={classes.exportText}>
              Please wait until the report is being downloaded
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ display: 'flex' }}>
      <PptSlides />
      <Export />
      <QuaterlyReportModal
        open={openQuaterlyReport}
        handleClose={() => setOpenQuaterlyReport(false)}
        isQuaterlyReport={true}
        setOpen={setOpenQuaterlyReport}
      />
    </div>
  );
});

export default ReportsPpt;
